import Skeleton from '@material-ui/lab/Skeleton'

import useStyles from './index.styles'

const UserAPIKeyRowSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <div className={classes.tableRow}>
      <div className={classes.expireDateCell}>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div className={classes.APIKeyCell}>
        <span>
          <Skeleton animation="wave" className={classes.skeleton} />
        </span>
      </div>
      <div className={classes.descriptionCell}>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
      <div className={classes.deleteIconCell}>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
    </div>
  )
}

export default UserAPIKeyRowSkeleton
